import { BrowserRouter, Routes, Route } from "react-router-dom";

import "./assets/themes/main.scss";

import { Header } from "./components/header/header";
import { Footer } from "./components/footer/footer";
import { HomePage } from "./pages/homePage";
import { AboutPage } from "./pages/aboutPage";
import { AvisoPage } from "./pages/avisoPage";
import { BolsaPage } from "./pages/bolsaPage";
import { ContactPage } from "./pages/contactPage";
import { CongresosEventosPage } from "./pages/services/congresosEventosPage";
import { StreamingPage } from "./pages/services/streamingPage";
import { WebDevelopPage } from "./pages/services/webDevelopPage";
import { MarketingPage } from "./pages/services/marketingPage";
import { DesignWebPage } from "./pages/services/desigWebPage";
import { PodcastPage } from "./pages/services/podcastPage";
import { BlogPage } from "./pages/blogPage";
import Viajes from "./pages/services/Viajes";
import { PostDetailPage } from "./pages/postDetailPage";

export default function App() {
  return (
    <BrowserRouter>
      <Header />
      <Routes>
        <Route exact path="/" element={<HomePage />} />
        <Route exact path="/nosotros" element={<AboutPage />} />
        <Route exact path="/contacto" element={<ContactPage />} />
        <Route exact path="/aviso" element={<AvisoPage />} />
        <Route exact path="/bolsa" element={<BolsaPage />} />
        <Route exact path="/blog" element={<BlogPage />} />
        <Route path="/blog/:id/:slug" element={<PostDetailPage />} />
        <Route
          exact
          path="/organizacion-congresos"
          element={<CongresosEventosPage />}
        />
        <Route exact path="/viajes" element={<Viajes />} />
        <Route exact path="/streaming" element={<StreamingPage />} />
        <Route exact path="/desarrollo-web-apps" element={<WebDevelopPage />} />
        <Route exact path="/diseno-grafico" element={<DesignWebPage />} />
        <Route
          exact
          path="/marketing-y-redes-sociales"
          element={<MarketingPage />}
        />
        <Route exact path="/produccion-audiovisual" element={<PodcastPage />} />
      </Routes>
      <Footer />
    </BrowserRouter>
  );
}
